import { render, staticRenderFns } from "./RoleAndPermission.vue?vue&type=template&id=f44b7f76&"
import script from "./RoleAndPermission.vue?vue&type=script&lang=js&"
export * from "./RoleAndPermission.vue?vue&type=script&lang=js&"
import style0 from "./RoleAndPermission.vue?vue&type=style&index=0&id=f44b7f76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports